module.exports = __webpack_public_path__ + "1d15aeecf0ad5d143ee83e008fb44d7f.svg";